module.exports = __webpack_public_path__ + "static/media/5-0.3c82a6ce.png";